export const AlertConstant = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    ERROR: 'ALERT_ERROR',
    ERRORMSG: 'ALERT_ERRORMSG',
    CLOSED: 'ALERT_CLOSED',
    CLEAR: 'ALERT_CLEAR',
    SET_TOP: 'SET_TOP',
};